export function getSafeLinkHref(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value || value !== value.trim()) {
    return undefined;
  }

  const hasUnsafeCharacter = Array.from(value).some(character => {
    const characterCode = character.charCodeAt(0);
    return (
      /\s/u.test(character) ||
      character === '\\' ||
      characterCode <= 31 ||
      (characterCode >= 127 && characterCode <= 159)
    );
  });
  if (hasUnsafeCharacter) {
    return undefined;
  }

  if (value.startsWith('/') && !value.startsWith('//')) {
    return value;
  }

  try {
    const url = new URL(value);
    if ((url.protocol === 'http:' || url.protocol === 'https:') && !url.username && !url.password) {
      return value;
    }
  } catch {
    return undefined;
  }

  return undefined;
}
